import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { PermissionEnum } from "../model/permission-enum";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({ providedIn: "root" })
export class LandingRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  async canActivate(): Promise<boolean> {
    if (Capacitor.isNativePlatform()) {
      await this.authenticationService.waitForInitialization();

      if (this.hasAdminPermission()) {
        this.router.navigate(["/employee-interface"], { replaceUrl: true });
      } else {
        this.router.navigate(["/clubs"], { replaceUrl: true });
      }
    } else {
      this.router.navigate(["/landing"], { replaceUrl: true });
    }
    return false;
  }

  private hasAdminPermission(): boolean {
    return this.authenticationService.currentUserPermissions.some(
      (permission: PermissionEnum) => permission == PermissionEnum.Admin,
    );
  }
}
